export default __webpack_public_path__ + "static/backend-as-a-service-3-ac3209aa57a1fd0aaf251ce702fe33e6.png";